import axios from 'axios';
import React,{Component} from 'react';
import { Button } from '../../components';
import css from './EditListingProfessionalInfoForm.module.css';
import { types as sdkTypes } from '../../util/sdkLoader';
const sharetribeSdk = require('sharetribe-flex-sdk');

const sdk = sharetribeSdk.createInstance({
    clientId: process.env.REACT_APP_SHARETRIBE_SDK_CLIENT_ID
  });

const { UUID } = sdkTypes;

class AzureUploadComponent extends Component { 

    state = { 
      // Initially, no file is selected 
      selectedFile: null
    }; 
     
    //this.props.listing.attributes.publicData.certificateUrl
    // On file select (from the pop up) 
    onFileChange = event => { 
      // Update the state 
      this.setState({ selectedFile: event.target.files[0] });
    }; 

    // On file upload (click the upload button) 
    onFileUpload = () => { 
    //Create an object of formData 
      const formData = new FormData(); 
     
      // Update the formData object 
      formData.append( 
        "image", 
        this.state.selectedFile, 
        this.state.selectedFile.name 
      ); 
     
      // Details of the uploaded file 

     
      // Request made to the backend api 
      // Send formData object 
      axios.post("/api/azure-upload", formData).then(resp => {
          //console.log(resp.data.blobUrl)
          
          const masterListingId = this.props.listing.id.uuid;
          const certificateUrl = resp.data.blobUrl;
          let uploadedfile = this.state.selectedFile.name;
        return sdk.ownListings.update({
            id: new UUID(masterListingId),
            privateData: {
                  certificateUrl: {
                      file: uploadedfile,
                      certificateUrl: certificateUrl
                    } 
              },
        }).catch(error => {
            console.log("error at updating master listing after azure upload")
      })   

      }).catch(error => {
          console.log(error)
      }); 
    //console.log(this.props.listing.id.uuid)
    }; 
     
    // File content to be displayed after 
    // file upload is complete 

     
    render() { 
      return ( 
           <div> 
                <input type="file" id="image" onChange={this.onFileChange} /> 
                <Button 
                className={css.submitButton}
                onClick={this.state.selectedFile === null ? console.log("nothing happens") : this.onFileUpload}
                > 
                  {this.props.message} 
                </Button> 
            </div> 
      ); 
    } 
  } 
  
  export default AzureUploadComponent; 